export default __webpack_public_path__ + "static/media/Artwork.91267b8c.png";